import ViewableTextField from '../../../fields/reduxForm/ViewableTextField';
import DateField from '../../../fields/reduxForm/DateField';
import CheckboxField from '../../../fields/reduxForm/GeneralCheckbox';

import {
  required,
  maxLength9,
  phone,
  email,
  auMobileNumber,
  auPhoneNumber,
  maxLength10,
} from '../../../utilities/validators';
// import {
//   normalizePhoneNumber,
//   normalizeMobileNumber,
// } from '../../../utilities/helpers';

const formFields = [
  {
    name: 'custom:buildingLicNo',
    component: ViewableTextField,
    props: {
      id: 'building-licence-number-text-field',
      label: 'Builder Licence Number',
      fullWidth: true,
    },
    validate: [required, maxLength9],
    normalize: null,
  },
  {
    name: 'custom:buildingLicExp',
    component: DateField,
    props: {
      id: 'building-licence-expiry-text-field',
      label: 'Builder License Expiry',
      fullWidth: true,
    },
    validate: [required, maxLength10],
    normalize: null,
  },
  {
    name: 'email',
    component: ViewableTextField,
    props: {
      id: 'personal-email-text-field',
      label: 'Email',
      fullWidth: true,
      disabled: true,
    },
    validate: [required, email],
    normalize: null,
  },
  {
    name: 'custom:personalPhone',
    component: ViewableTextField,
    props: {
      id: 'personal-phone-text-field',
      label: 'Primary Contact Number',
      fullWidth: true,
      placeholder: 'e.g. 0292345678 or 0430987654',
    },
    validate: [required, auPhoneNumber],
    // normalize: normalizePhoneNumber,
  },
  {
    name: 'custom:mobileNumber',
    component: 'ViewableTextField',
    props: {
      id: 'mobile-phone-text-field',
      label: 'Mobile Phone',
      fullWidth: true,
      placeholder: 'e.g. 0430987654',
    },
    validate: [phone, auMobileNumber],
    // normalize: normalizeMobileNumber,
  },
  {
    name: 'priorityListing',
    component: CheckboxField,
    props: {
      id: 'priority-listing-text-field',
      label: 'PRIORITY LISTING',
      disabled: 'disable',
    },
  },
  // {
  //   name: 'deactivate',
  //   component: CheckwithDrop,
  //   props: {
  //     id: 'deactivate-text-field',
  //     label: 'DEACTIVATE',
  //     disabled: 'disable',
  //   }
  // },
];

export default formFields;
